module.exports = __webpack_public_path__ + "static/media/Ilustración de Portada_Gustavo Guarnizo_Piura.3516c1f6.jpg";